export default "__VITE_ASSET__CP8Z9oDf__"